import {
  globalReleaseConstants,
  addGlobalReleaseConstants,
  editGlobalReleaseConstants,
} from "../_redux-constants";
import { globalReleaseService } from "../../_services";

function getGlobalRelease() {
  function getGlobalReleaseLoad() {
    return { type: globalReleaseConstants.GLOBAL_RELEASE_LOADING };
  }
  function GlobalReleaseSuccess(data) {
    return { type: globalReleaseConstants.GLOBAL_RELEASE_SUCCESS, data };
  }
  function GlobalReleaseFailure(error) {
    return { type: globalReleaseConstants.GLOBAL_RELEASE_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getGlobalReleaseLoad());
    return globalReleaseService.getGlobalRelease().then(
      (data) => {
        dispatch(GlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(GlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addGlobalRelease(formData) {
  function addGlobalReleaseLoad() {
    return { type: addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_LOADING };
  }
  function addGlobalReleaseSuccess(data) {
    return { type: addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_SUCCESS, data };
  }
  function addGlobalReleaseFailure(error) {
    return {
      type: addGlobalReleaseConstants.ADD_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addGlobalReleaseLoad());
    return globalReleaseService.addGlobalRelease(formData).then(
      (data) => {
        dispatch(addGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editGlobalRelease(formData) {
  function editGlobalReleaseLoad() {
    return { type: editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_LOADING };
  }
  function editGlobalReleaseSuccess(data) {
    return {
      type: editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editGlobalReleaseFailure(error) {
    return {
      type: editGlobalReleaseConstants.EDIT_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editGlobalReleaseLoad());
    return globalReleaseService.editGlobalRelease(formData).then(
      (data) => {
        dispatch(editGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const globalReleaseActions = {
  getGlobalRelease,
  addGlobalRelease,
  editGlobalRelease,
};
